const leadwayOfferings = [
  {
    id: "comprehensive-quarter",
    name: "Motor Comprehensive (3 months)",
    description:
      "Leadway's Comprehensive Motor Insurance  offers a comprehensive cover which includes loss of or accidental damage to the vehicle of the insured and also indemnifies for damage to Third Party vehicles/ properties as well as third party personal injury or death arising as a result of any accident from the use of the insured vehicle(s)",
    benefits: [
      "3 months comprehensive insurance coverage",
      "Third Party cover up to a limit of ₦3,000,000",
      "Accidental damage to your vehicle",
      "Fire damage to your vehicle",
      "Theft of your vehicle or vehicle parts",
      "Damage caused by flood to your vehicle",
      "Damages caused by strike, riots & civic commotion (SRCC)",
      "Damage to third party property up to ₦3,000,000",
      "Accident leading to injury/death of a third party",
      "ECOWAS Brown Card (For liability while driving within West African countries)",
      "Medical Expenses (Limited to N30,000 Only)",
      "Towing Expenses (Payment limited to N30,000 only within the state and N50,000 only outside the state)",
    ],
    note: "You will miss out on getting a free vehicle tracker with this plan, you may want to check out the 12-month comprehensive insurance plan",
    price: {
      premiumCostPercentage: 0.9,
      premiumAmountPercentage: 1,
    },
    premiumRatePercentage: 0.0125,
  },
  {
    id: "comprehensive-half",
    name: "Motor Comprehensive (6 months)",
    description:
      "Leadway's Comprehensive Motor Insurance  offers a comprehensive cover which includes loss of or accidental damage to the vehicle of the insured and also indemnifies for damage to Third Party vehicles/ properties as well as third party personal injury or death arising as a result of any accident from the use of the insured vehicle(s)",
    benefits: [
      "6 months comprehensive insurance coverage",
      "Third Party cover up to a limit of ₦3,000,000",
      "Accidental damage to your vehicle",
      "Fire damage to your vehicle",
      "Theft of your vehicle or vehicle parts",
      "Damage caused by flood to your vehicle",
      "Damages caused by strike, riots & civic commotion (SRCC)",
      "Damage to third party property up to ₦3,000,000",
      "Accident leading to injury/death of a third party",
      "ECOWAS Brown Card (For liability while driving within West African countries)",
      "Medical Expenses (Limited to N30,000 Only)",
      "Towing Expenses (Payment limited to N30,000 only within the state and N50,000 only outside the state)",
    ],
    price: {
      premiumCostPercentage: 0.9,
      premiumAmountPercentage: 1,
    },
    premiumRatePercentage: 0.025,
  },
  {
    id: "comprehensive",
    name: "Motor Comprehensive (12 months)",
    description:
      "Leadway's Comprehensive Motor Insurance  offers a comprehensive cover which includes loss of or accidental damage to the vehicle of the insured and also indemnifies for damage to Third Party vehicles/ properties as well as third party personal injury or death arising as a result of any accident from the use of the insured vehicle(s)",
    benefits: [
      "12 months comprehensive insurance coverage",
      "Third Party cover up to a limit of ₦3,000,000",
      "Accidental damage to your vehicle",
      "Fire damage to your vehicle",
      "Theft of your vehicle or vehicle parts",
      "Free tracker for vehicle above ₦5,000,000",
      "Damage caused by flood to your vehicle",
      "Damages caused by strike, riots & civic commotion (SRCC)",
      "Damage to third party property up to ₦3,000,000",
      "Accident leading to injury/death of a third party",
      "ECOWAS Brown Card (For liability while driving within West African countries)",
      "Medical Expenses (Limited to N30,000 Only)",
      "Towing Expenses (Payment limited to N30,000 only within the state and N50,000 only outside the state)",
    ],
    price: {
      premiumCostPercentage: 0.9,
      premiumAmountPercentage: 1,
    },
    premiumRatePercentage: 0.05,
  },
  {
    id: "autobase",
    name: "Autobase",
    description:
      "Leadway Autobase motor insurance is a specially designed product that covers the claims in third party insurance, as well as a partial coverage for one’s owned vehicle to a limit of ₦500,000.",
    benefits: [
      "Third Party cover up to a limit of ₦3,000,000",
      "Cover for accidental damages to your vehicle up to a limit of ₦500,000",
    ],
    price: {
      premiumCost: 27000,
      premiumAmount: 30000,
    },
  },
]

const comprehensiveInsurance = [
  {
    id: "leadway",
    name: "Leadway Assurance",
    offerings: leadwayOfferings,
  },
]

const comprehensiveInsuranceDocs = {
  key: "ci",
  name: "Comprehensive Insurance",
  description:
    "Either a comprehensive or third-party insurance is required for vehicles",
  connected: [],
  process: [],
  processingTime: 2,
  price: [],
  meta: {},
}

module.exports = {
  comprehensiveInsurance,
  comprehensiveInsuranceDocs,
}
